var map = {
	"./auth/client/lang/client.zh.js": "OwpP",
	"./auth/menu/lang/menu.zh.js": "qtes",
	"./auth/pageOp/lang/pageOp.zh.js": "8nTJ",
	"./auth/permission/lang/permissions.zh.js": "wdx8",
	"./auth/role/lang/role.zh.js": "jWB2",
	"./auth/user/lang/user.zh.js": "yU40",
	"./case/bestPractices/lang/bestPractices.zh.js": "HmL9",
	"./dataManagement/clockInData/lang/clockInData.zh.js": "/mfX",
	"./dataManagement/pointsStatistics/lang/pointsStatistics.zh.js": "Bfih",
	"./home/lang/home.zh.js": "JRhZ",
	"./md/areaCity/lang/areaCity.zh.js": "uI9y",
	"./md/distributor/lang/distributor.zh.js": "cLJO",
	"./pointsManagement/byCoupon/lang/byCoupon.zh.js": "7G4p",
	"./pointsManagement/userPoints/lang/userPoints.zh.js": "SM/4",
	"./taskManagement/taskApproval/lang/taskApproval.zh.js": "1BgO",
	"./taskManagement/taskList/lang/taskList.zh.js": "Oe+R",
	"./zhubo/finance/lang/finance.zh.js": "QOxW",
	"./zhubo/orderQuery/lang/orderQuery.zh.js": "C4pU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NMad";


//////////////////
// WEBPACK FOOTER
// ./src/page \.zh.js$
// module id = NMad
// module chunks = 77